<script setup lang="ts">
// An icon from Stratus v2's set (icons.ts), in currentColor. Decorative by default
// (aria-hidden); give it a `label` when it's the only thing saying what it means.
// Its base style (.itc-icon) is in components.css, so where it sits can size it.
import { computed } from 'vue';
import { ICONS, type IconName } from '../icons.ts';

const props = defineProps<{ name: IconName; label?: string; size?: number }>();
const shapes = computed(() => ICONS[props.name]);
</script>

<template>
  <svg
    class="itc-icon"
    viewBox="0 0 24 24"
    :style="size ? { width: `${size}px`, height: `${size}px` } : undefined"
    :role="label ? 'img' : undefined"
    :aria-label="label"
    :aria-hidden="label ? undefined : 'true'"
    focusable="false"
  >
    <component :is="shape[0]" v-for="(shape, index) in shapes" :key="index" v-bind="shape[1]" />
  </svg>
</template>
